import ElementGroups from "@ext/markdown/core/element/ElementGroups";
import { DEFAULT_GALLERY_VIEW } from "@ext/markdown/elements/gallery/model/gallery";

const gallerySchema = {
	group: `${ElementGroups.block} ${ElementGroups.listItemContent}`,
	content: `${ElementGroups.galleryItem}+`,
	defining: true,
	draggable: true,
	attrs: {
		view: { default: DEFAULT_GALLERY_VIEW },
		title: { default: null },
	},
};

export default gallerySchema;
